export class Paths {
  addLocality() {
    return '/add-locality'
  }
}
